export default __webpack_public_path__ + "static/media/Stuck at Home Searching.ee130549.png";